import "./Experience.css";

const Experience = (props) => {
  return (
    <section className={"experience " + props.className} id="experience">
      <div className="worked">
        <div className="container">
        <p className="para-worked">Where I've Worked </p>
        {/* <p className="imp"></p> */}
        </div>
        <div className="exp-content">
            <div className="company-desig">
          <p className="company">Accenture (Aug 2022- Jan 2023)</p>
          <p className="designation">Asessor and Coder (TPR)</p>
          </div>
          <ul className="expcontent">
            <li>Perform data analysis and research in various systems and tracking
            tools.</li>
            <li>Apply knowledge of processes and related systems to assist
            identifying ,assessing and resolving issues.</li>
            <li>Seek advice and
            escalate issues when faced with problems outside the scope of work.</li>
              
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Experience;
